import * as Preact from "preact"
import Random from "@frog/source/utility/Random.js"
const random = new Random()
import Loop from "@frog/source/engine/Loop.js"
import App from "@frog/source/models/App.js"

import "@frog/source/views/components/Snow.less"

const AMOUNT = 128
const FRAME_WIDTH = 16
const FRAME_HEIGHT = 9

const particles = []
for(let i = 0; i < AMOUNT; i += 1) {
    particles.push({
        "scale": (i % 3) + 1,
        "position": {
            "x": random.range(-FRAME_WIDTH, FRAME_WIDTH * 2),
            "y": random.range(-FRAME_HEIGHT, FRAME_HEIGHT),
        },
        "velocity": {
            "y": 0.05,
            "x": random.range(-0.05, 0.05)
        }
    })
}

export default class Snow {
    render() {
        if(App.game.chapter.decorations?.hasSnow != true) return
        return (
            <div class="Snow">
                {particles.map((particle) => {

                    let speed = 0.5
                    const dyingUnit = Object.values(this.props.stage.units).find((unit) => {
                        return unit.isDead != true && unit.deathTimer != undefined
                    })
                    if(dyingUnit != undefined) {
                        speed = 0.8
                    }

                    particle.position.x += particle.velocity.x * Loop.delta.f * speed
                    particle.position.x += Math.sin(Loop.time.s) * 0.1 * speed
                    particle.position.y += particle.velocity.y * Loop.delta.f * speed

                    if(particle.position.y > FRAME_HEIGHT + 1) {
                        particle.position.x = random.range(0, FRAME_WIDTH)
                        particle.position.y = random.range(0, FRAME_HEIGHT) * -1
                    }
                    return (
                        <div class="SnowParticle" style={{
                            "left": particle.position.x + "em",
                            "top": particle.position.y + "em",
                            "width": (0.05 * particle.scale) + "em",
                            "height": (0.05 * particle.scale) + "em",
                        }}/>
                    )
                })}
            </div>
        )
    }
}
